module.exports = __webpack_public_path__ + "img/Logo.9da668ec.svg";